export default __webpack_public_path__ + "static/media/qua2.0859e6bd.jpg";